export default "__VITE_ASSET__7M4lpJ1f__"